import React from "react";
import { motion } from "framer-motion";
import ctaBg from "../Images/cta-bg.webp";

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 50,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const Cta = () => {
  return (
    <motion.section
      className="cta-section"
      style={{ backgroundImage: `url(${ctaBg})` }}
      initial={{
        scale: 1.08,
      }}
      whileInView={{
        scale: 1,
      }}
      viewport={{ once: true }}
      transition={{
        duration: 1.4,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      <div className="container">

        <motion.div
          className="cta-glass"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >

          <motion.div
            className="cta-glow"
            animate={{
              scale: [1, 1.08, 1],
              opacity: [.45, .75, .45],
            }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />

          <motion.h2
            className="section-heading"
            variants={fadeUp}
          >
            Your next customer is already on WhatsApp.
          </motion.h2>

          <motion.p
            className="section-text"
            variants={fadeUp}
          >
            No setup fees. No technical skills needed.
            We build your first automation flow live
            on the demo call.
          </motion.p>

          <motion.div variants={fadeUp}>

            <motion.div
              whileHover={{
                scale: 1.05,
                y: -4,
              }}
              whileTap={{
                scale: .97,
              }}
            >

              <a
                href="https://app.onbbits.io/register"
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary"
              >
                Get Started For Free
              </a>

            </motion.div>

          </motion.div>

        </motion.div>

      </div>
    </motion.section>
  );
};

export default Cta;